import React from 'react'
import { StyleSheet, ScrollView, Dimensions, TouchableOpacity } from 'react-native'
import { Button, Modal, Text, Toggle, Icon, useTheme } from '@ui-kitten/components'
import { useTranslation } from 'react-i18next'
import { newSaleInterfaceSettingsAtom, userRoleAtom } from '../global/AtomsProvider'
import { useAtom, useAtomValue } from 'jotai'
import { constantsAtom } from '../global/AtomsProvider'
import StyledTextInput from './StyledTextInput'

export const NewSaleSettingsModal = React.memo(function NewSaleSettingsModal({ settingsModalVisible, setSettingsModalVisible, navigation }) {
  const { t } = useTranslation()
  const theme = useTheme()
  const [newSaleInterfaceSettings, setNewSaleInterfaceSettings] = useAtom(newSaleInterfaceSettingsAtom)
  const userRole = useAtomValue(userRoleAtom)
  const constants = useAtomValue(constantsAtom)

  return (
    <Modal style={[styles.modal, { backgroundColor: theme['background-basic-color-1'] }]}
      visible={settingsModalVisible} 
      backdropStyle={styles.backdrop} 
      onBackdropPress={() => setSettingsModalVisible(false)}
    >
      <ScrollView style={{flex: 1}} contentContainerStyle={styles.modalContainer}>
        <TouchableOpacity 
          style={{position: 'absolute', top: 10, right: 10, alignSelf: 'flex-end', alignItems: 'center', justifyContent: 'center'}} 
          onPress={() => {
            setSettingsModalVisible(false)
          }}
        > 
          <Icon name='close-circle' width={32} height={32} fill={theme['text-basic-color']} />
        </TouchableOpacity>
        <Text category='h1' style={{marginBottom: 10}}>{t('newSale.interfaceSettingsTitle')}</Text>
        <Text category='h3' style={styles.label}>
          {t('newSale.appearance')}
        </Text>
        { Dimensions.get('window').width >= 500 && (
          <>
            <Text category='label' style={styles.label}>
              {t('newSale.gridLeftWidth')}
            </Text>
            <StyledTextInput
              value={String(newSaleInterfaceSettings?.gridLeftWidth ?? '')}
              onChangeText={(value) => {
                if (value.trim() !== '') {
                  const parsed = parseInt(value)
                  if (!isNaN(parsed)) setNewSaleInterfaceSettings(current => ({...current, gridLeftWidth: parsed}))
                }
              }}
              keyboardType='numeric'
              style={{marginBottom: 10}}
            />
          </>
        )}
        <Text category='label' style={styles.label}>
          {t('newSale.checkoutStyle2Steps')}
        </Text>
        <Toggle 
          checked={newSaleInterfaceSettings?.checkoutStyle == 2}
          onChange={(value) => {
            setNewSaleInterfaceSettings(current => ({...current, checkoutStyle: (value ? 2 : 1)}))
          }}
          style={styles.toggleField}
        >
          {t('newSale.checkoutStyle2Steps')}
        </Toggle>
        <Text category='h3' style={styles.label}>
          {t('newSale.internalReceipt')}
        </Text>
        <Text category='label' style={styles.label}>
          {t('newSale.internalReceiptWidth')}
        </Text>
        <StyledTextInput 
          value={newSaleInterfaceSettings?.internalReceiptWidth}
          onChangeText={(value) => {
            if (value.trim() !== '') value = parseInt(value)
            if (!isNaN(value)) setNewSaleInterfaceSettings(current => ({...current, internalReceiptWidth: value}))
          }}
          keyboardType='numeric'
          style={{marginBottom: 10}}
        />
        <Text category='label' style={styles.label}>
          {t('newSale.internalReceiptFontSize')}
        </Text>
        <StyledTextInput 
          value={newSaleInterfaceSettings?.internalReceiptFontSize}
          onChangeText={(value) => {
            if (value.trim() !== '') value = parseInt(value)
            if (!isNaN(value)) setNewSaleInterfaceSettings(current => ({...current, internalReceiptFontSize: value}))
          }}
          keyboardType='numeric'
          style={{marginBottom: 10}}
        />
        { (userRole?.permissions?.['editSettings'] || userRole?.id === 'admin') && (
          <>
            <Button appearance='outline' style={[styles.button, {marginTop: 16}]} onPress={() => {
              setSettingsModalVisible(false)
              navigation.navigate('UniversalList', {atom: constantsAtom, initialDataPath:  ['paymentMethods', 'data'], searchField: 'name', detailScreen: 'PaymentMethodDetail', title: t('paymentMethods')})
            }}>{t('configure') + ' ' + t('paymentMethods')}</Button>
            <Button appearance='outline' style={styles.button} onPress={() => {
              setSettingsModalVisible(false)
              navigation.navigate('UniversalList', {atom: constantsAtom, initialDataPath:  ['purchaseMethods', 'data'], searchField: 'name', detailScreen: 'PurchaseMethodDetail', title: t('purchaseMethods')})
            }}>{t('configure') + ' ' + t('purchaseMethods')}</Button>
            <Button appearance='outline' style={styles.button} onPress={() => {
              setSettingsModalVisible(false)
              navigation.navigate('EditableList', {atom: constantsAtom, initialDataPath: ['discountOptions', 'data'], title: t('discountOptions'), ref: constants?.discountOptions.ref})
            }}>{t('configure') + ' ' + t('discountOptions')}</Button>
            <Button appearance='outline' style={styles.button} onPress={() => {
              setSettingsModalVisible(false)
              navigation.navigate('SaleSettings')
            }}>{t('moreSettings')}</Button>
          </>
        )}
      </ScrollView>
    </Modal>
  )
}, function(prev, next) {
  if (prev.settingsModalVisible !== next.settingsModalVisible) {
    return false
  }
  if (prev.checkoutStyle !== next.checkoutStyle) {
    return false
  }
  return true
})

const styles = StyleSheet.create({
  modal: {
    top: 100,
    width: '80%',
    height: '80%',
    borderRadius: 20,
  },
  modalContainer: {
    // justifyContent: 'space-around',
    alignItems: 'stretch',
    padding: 32,
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  toggleField: {
    flex: 1,
    marginBottom: 10,
    alignSelf: 'flex-start'
  },
  toggleText: {
   flexShrink: 1
  },
  button: {
    marginVertical: 5
  },
  radio: {
    marginBottom: 5
  },
  label: {
    marginBottom: 8,
    marginTop: 8,
  },
})
